module.exports = __webpack_public_path__ + "img/gal-7.2c33b82b.jpg";